module.exports = __webpack_public_path__ + "img/Honduras1.e3bd0684.png";